import httpClient from '@shared/http/client';
import { setResponseCache, getResponseCache } from './cache';

export const loadSource = (url, options = { cache: true }) =>
  new Promise(async resolve => {
    if (options.cache) {
      const cached = getResponseCache(url);
      if (cached) return resolve(cached);
    }

    try {
      const response = await httpClient.get(url);
      const data = response.data;
      if (options.cache) setResponseCache(url, data);
      resolve(data);
    } catch (err) {
      console.log(err);
      resolve(null);
    }
  });
